module.exports = "<div ng-if=\"props.plan.primaryFs.id && !props.plan.primaryFs.isPreferred\" class=\"checkboxFiPreferred sCheckbox checkbox\" ng-class=\"plan.primaryFs.name\" content>\n    <input type=\"checkbox\" ng-model=\"makeFiPreferred.selected\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" ng-change=\"actions.toggleModel()\">\n    <label for=\"makeFiPreferred\">{{ content('memberReview.preferredCheckbox') }}</label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/preferred-checkbox/template.html
// module id = ./components/xo-member-components/src/preferred-checkbox/template.html
// module chunks = 1